export const ON_TOUCH_START = 'ontouchstart';
export const TOUCH_MOVE = 'touchmove';
export const TOUCH_START = 'touchstart';
export const TOUCH_END = 'touchend';
export const SWIPE_LEFT = 'swipe-left';
export const SWIPE_RIGHT = 'swipe-right';



